module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/notokr-bold.woff
// module id = luKs
// module chunks = 0